module.exports = __webpack_public_path__ + "static/media/goldenGateHeroImage.3cc5856b.jpeg";